/**
 * ------------------------------------------------------------------------------------------------------------------
 * REQUIRE SIZE SELECTION
 * ------------------------------------------------------------------------------------------------------------------
 *
 * Verhindert, dass Kunden ungewollt die vorausgewählte erste verfügbare Größe (meist "S") kaufen, ohne aktiv eine
 * Größe gewählt zu haben. Shopify wählt serverseitig immer automatisch eine Variante vor (kein Weg das über
 * Liquid allein abzuschalten) - dieses Skript entfernt nur die sichtbare/native Auswahl beim Laden und sperrt den
 * Kauf-Button, bis der Kunde selbst klickt. Absprache 2026-09-14.
 *
 * WICHTIG - bewusst NICHT in assets/theme.js (kompiliert/obfuskiert) oder die "variant-picker"-Web-Component
 * eingegriffen, das wäre deutlich riskanter. Dieses Skript ist rein additiv:
 *   1. Entfernt beim Laden das "checked"-Attribut der GRÖSSEN-Radios per DOM-Zugriff (kein .click(), löst also
 *      KEIN "change"-Event aus - der eingebaute variant-picker merkt davon nichts und rendert nicht neu).
 *   2. Sperrt den/die Kauf-Button(s) des zugehörigen Formulars, bis ein echtes "change"-Event auf der
 *      Größen-Option eintritt (= der Kunde hat wirklich selbst geklickt).
 *   3. Ab dem ersten echten Klick übernimmt wieder komplett der normale, unveränderte Ablauf des Theme - dieses
 *      Skript greift danach nicht mehr ein.
 *
 * Nur auf der Produktseite eingebunden (sections/main-product.liquid), bewusst NICHT bei Schnellkauf/Quick-Buy
 * oder Produktkarten - dort ist eine Vorauswahl unkritischer und der Kontext ist ein anderer.
 *
 * Betrifft nur die Option mit dem Namen "general.label.size" (aktuell "Größe") - Farboptionen o. Ä. bleiben
 * unverändert vorausgewählt, das ist dort nicht das Problem.
 */
(function () {
  "use strict";

  // Entspricht der Übersetzung "general.label.size" in locales/de.json. Falls der Shop mehrsprachig wird und
  // eine andere Sprache ein anderes Wort für die Options-Bezeichnung "Größe" verwendet, hier ergänzen.
  var SIZE_LABEL = "Größe";
  var PLACEHOLDER_TEXT = "Bitte wählen";

  function findSizeFieldset(picker) {
    var fieldsets = picker.querySelectorAll(".variant-picker__option");

    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector("legend");

      // Legend-Text ist "{{ option.name }}:" (siehe snippets/variant-picker.liquid), daher hier den
      // Doppelpunkt am Ende mit abschneiden, statt exakt zu vergleichen.
      if (legend && legend.textContent.trim().replace(/:$/, "").toLowerCase() === SIZE_LABEL.toLowerCase()) {
        return fieldsets[i];
      }
    }

    return null;
  }

  function setUp(product) {
    if (product.hasAttribute("data-require-size-selection-done")) return;

    var picker = product.querySelector("variant-picker");
    if (!picker) return;

    var sizeFieldset = findSizeFieldset(picker);
    if (!sizeFieldset) return;

    var sizeInputs = sizeFieldset.querySelectorAll('input[type="radio"]');
    if (!sizeInputs.length) return;

    var formId = picker.getAttribute("form-id");
    if (!formId) return;

    var submitButtons = document.querySelectorAll('button[type="submit"][form="' + formId + '"]');
    if (!submitButtons.length) return;

    product.setAttribute("data-require-size-selection-done", "true");

    var selectedValueEl = sizeFieldset.querySelector(".variant-picker__option-info span:last-child");
    var originalValueText = selectedValueEl ? selectedValueEl.textContent : "";

    sizeInputs.forEach(function (input) {
      input.checked = false;
    });

    if (selectedValueEl) {
      selectedValueEl.textContent = PLACEHOLDER_TEXT;
    }

    submitButtons.forEach(function (button) {
      button.disabled = true;
      button.setAttribute("data-awaiting-size-selection", "true");
    });

    sizeFieldset.addEventListener(
      "change",
      function () {
        submitButtons.forEach(function (button) {
          button.disabled = false;
          button.removeAttribute("data-awaiting-size-selection");
        });

        if (selectedValueEl && selectedValueEl.textContent === PLACEHOLDER_TEXT) {
          selectedValueEl.textContent = originalValueText;
        }
      },
      { once: true }
    );
  }

  function setUpAll(root) {
    (root || document).querySelectorAll(".product").forEach(setUp);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      setUpAll(document);
    });
  } else {
    setUpAll(document);
  }

  // Theme-Editor: Section wird neu geladen/hinzugefügt (z. B. beim Bearbeiten im Editor-Vorschau).
  document.addEventListener("shopify:section:load", function (event) {
    setUpAll(event.target);
  });
})();
